import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IKundenResponseRow } from 'fa-kt.types';
import { BehaviorSubject } from 'rxjs';
import { KundenService } from '../service';

@Component({
  selector: 'fa-kt-kunden-list',
  templateUrl: './kunden-list.component.html',
  styleUrls: ['./kunden-list.component.css'],
})
export class KundenListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public kunden: KundenService) {}

  public set(kunden: IKundenResponseRow) {
    /* << custom    */
    this.select.emit(kunden.kunde.id);
    /*    custom >> */
  }
}
